/**
 * Estima el FTP (Functional Threshold Power) desde un array de registros.
 * Utiliza la mejor potencia promedio sostenida durante 20 minutos.
 *
 * @param {Array} records - Array de objetos que contienen el campo `power`.
 * @returns {number|null} FTP estimado o null si no hay suficientes datos.
 */
function estimateFTPFrom20MinTest(records = []) {
  if (!Array.isArray(records)) return null;

  const powerValues = records
    .map(r => r.power)
    .filter(p => typeof p === 'number' && p > 0);

  if (powerValues.length < 1200) {
    console.warn('❌ No hay suficientes valores para estimar FTP (mínimo 20 minutos).');
    return null;
  }

  let maxAvg = 0;
  for (let i = 0; i <= powerValues.length - 1200; i++) {
    const window = powerValues.slice(i, i + 1200);
    const avg = window.reduce((sum, val) => sum + val, 0) / 1200;
    if (avg > maxAvg) maxAvg = avg;
  }

  return Math.round(maxAvg * 0.95);
}

module.exports = {
  estimateFTPFrom20MinTest
};
